export default __webpack_public_path__ + "static/media/049-bike.000ff926.svg";